import React, {useState, useContext, useEffect, useRef}from "react";
import {SesionContext} from '../../../context/SesionContext';
import { apiCall } from "../../../helpers/ApiCalls";
import "../../../dhtmlx/codebase/suite.css";
import "../Inicio/form.css";
import {showAlert} from "../../globals/Message";
import styled from "styled-components";
import {Row, Col} from 'react-bootstrap';
import Titulo from "../../globals/Title";
import {Formulario} from "../../globals/dhtmlx/Formeditar";
import Button from "../../globals/Button";
import Loader from "../../globals/Loader";

/**ESTILOS */
const Wrapper = styled.div`
    width:100%;
    overflow-y:hidden;
`;
const Container = styled.section`
    width: 500px;
    display: ${props => props.show};
    justify-content: center;
    align-content: center;
    height: auto;
    padding: 16px 0 16px 0;
    margin-left: 30px;
    max-width:500px;
`;
const HeaderContainer = styled(Row)`
    margin: 8px 0 24px;
`;
const ColStyle = styled(Col)`
    margin:0;
    padding:0;
    display:flex;
    justify-content:${props => props.align};
    align-items:center;
`;
const LoginMessage = styled.span`
    color: red;
    text-align: center;
    font-size: 15px;
`;

function Perfil(props){
    const {cerrarSesion} = useContext(SesionContext);
  
    const [valid, setValid] = useState(true);
    const [inputs, setInputs] = useState({}); //guarda valores de los inputs
    const [loginMessage, setLoginMessage] = useState("");
    const [showLoginMessage, setShowLoginMessage] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [ready, setReady] = useState(false); //controla el mostrar el form o el loader
    const [nombreAux, setNombreAux] = useState(null); //controla el nombre para que no se actualiza en la pantalla
    const [idUser, setIdUser] = useState(null); //contiene el id, porque lo borra cuando se hace un cambio a los otro inputs

    //usamos array vacio para hacer la "invocacion en cuanto se llame le vista"
    useEffect(()=>{
        apiCall('GET','usuario').then((res)=>{
            llenaInputs(res);
        });
    }, []);

    function llenaInputs(result){
        if(result.success){
            //asigna valores a los estados y cambia bandera par mostrar el form
            setInputs({"id": result.data.id, "nombre": result.data.nombre, "apellido": result.data.apellido, "email": result.data.email, "proveedor": result.data.proveedor.nombre});
            setNombreAux(result.data.nombre+" "+result.data.apellido);
            setIdUser({"id": result.data.id});
            setReady(true);
        }else{
            if(result.code === 401){
                showAlert("La sesión caducó, por favor ingresa de nuevo");
                cerrarSesion();
            }else{
                if(result.code === 503){
                    showAlert("Estamos en mantenimiento intenta ingresar más tarde");
                    cerrarSesion();
                }
                else{
                    showAlert("No se encontro información en este perido de los elementos seleccionados")
                    setReady(true);
                }
            }
        }
    }

    const editarPerfil= (e)=> {
        e.preventDefault();
        setButtonLoading(true);
        if(!valid || inputs.nombre.trim() === "" || inputs.apellido.trim() === "" || inputs.email.trim() ===""){
            setButtonLoading(false);
            return
        }
        //agrega el id al objeto "principal"
        setInputs(Object.assign(inputs, idUser));
        let params = inputs;
        //request a la API para que haga update
        apiCall('PUT', 'usuario', params)
            .then((res)=>{
                console.log(res);
                setButtonLoading(false);
                if(res.success && res.code === 200){
                    setNombreAux(inputs.nombre+" "+inputs.apellido);
                    showAlert("Se ha actualizado tu informacion correctamente");
                }else{
                    if(res.code === 401){
                        showAlert("La sesión caducó, por favor ingresa de nuevo");
                        cerrarSesion();
                    }else{
                        showAlert("Verifica que todos los")
                        setReady(true);
                    }
                }
            })
    }

    //inputs para mandar al form de dhtmlx
    const rows= [
        {
            id: "nombre",
            type: "input",
            inputType: "text",
            label: "Nombre",
            placeholder: "Nombre",
            value: `${inputs.nombre}`,
            errorMessage: "Ingresa un nombre",
            successMessage: "Nombre valido",
            required: true
        },
        {
            id: "apellido",
            type: "input",
            inputType: "text",
            label: "Apellido",
            placeholder: "Apellido",
            value: `${inputs.apellido}`,
            errorMessage: "Ingresa apellido",
            successMessage: "Apellido valido",
            required: true,
        },
        {
            id: "email",
            type: "input",
            inputType: "text",
            label: "Correo",
            placeholder: "Correo",
            required: true,
            value: `${inputs.email}`,
            errorMessage: "Ingresa un correo",
            successMessage: "Correo valido",
            validation: "email"
        },
        {
            id: "proveedor",
            type: "input",
            inputType: "text",
            label: "Proveedor",
            placeholder: "Provedor",
            value: `${inputs.proveedor}`,
            errorMessage: "Ingrese el proveedor",
            successMessage: "Proveedor valido",
            require: true,
        }
    ];

    if(ready){
        return(
            <Wrapper id="editar_perfil">
                <HeaderContainer id="header_container">
                    <ColStyle align={'start'}>
                        {/* <Titulo tipo={'Perfil'} nombre={inputs.nombre+" "+inputs.apellido}/> */}
                        <Titulo tipo={'Perfil'} nombre={nombreAux}/>
                    </ColStyle>
                    <ColStyle md={'auto'} align={'end'} style={{marginTop:'0px'}}></ColStyle>
                </HeaderContainer>
                <Container id={'form-container'}>
                    <div style={{background: "#fff", borderRadius:"5px"}}>
                        <LoginMessage id="login_message" style={{display:showLoginMessage? "":"none"}}>
                            ** {loginMessage} **
                        </LoginMessage>
                        <Formulario
                            rows={rows}
                            padding = {0}
                            width = {'100%'}
                            toggleInputs = {setInputs}
                            toggleValid = {setValid}
                            toogleMessage = {setShowLoginMessage}
                            loading = {buttonLoading}
                        />
                        {
                            <div style={{textAlign: "center", paddingBottom: "16px"}}>
                                <Button width={'79%'} flat={true} loading={buttonLoading} onClick={(e)=> {editarPerfil(e)}}>Actualizar</Button>
                                {/* <Button width={49} flat={false} loading={buttonLoading}>Cancelar</Button> */}
                            </div>
                        }
                    </div>
                </Container>
            </Wrapper>
        );
    }else{
        return(
            <Loader/>
        );
    }
}
export default Perfil;